import { render, staticRenderFns } from "./AugmentationsContent.vue?vue&type=template&id=c15b2c4c&scoped=true&"
import script from "./AugmentationsContent.vue?vue&type=script&lang=js&"
export * from "./AugmentationsContent.vue?vue&type=script&lang=js&"
import style0 from "./AugmentationsContent.vue?vue&type=style&index=0&id=c15b2c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15b2c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTabsSlider})
